import { Card, CardBody, Col } from 'reactstrap'
import { LI, UL } from '../../../../../AbstractElements'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { FollowUsTitle } from '../../../../../Utils/Constants'

export default function FollowUs() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={FollowUsTitle} />
                <CardBody>
                    <UL className="blog-follow simple-list flex-row">
                        <LI><a href="https://en-gb.facebook.com/login/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook-square" /></a></LI>
                        <LI><a href="https://twitter.com/LOGIN" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a></LI>
                        <LI><a href="https://www.instagram.com/accounts/login/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram" /></a></LI>
                        <LI><a href="https://www.skype.com/en/" target="_blank" rel="noopener noreferrer"><i className="fa fa-skype" /></a></LI>
                        <LI><a href="https://www.linkedin.com/login" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin" /></a></LI>
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}